import { PROMO } from 'apps/promo/constants/EntryPoint';
import { NO_AUTH_VIEW } from 'apps/promo/constants/ServerConstants';
import LibreNoAuthChequePage from 'apps/promo/pages/info/LibreNoAuthChequePage';
import RouterForInfoPage from 'apps/promo/pages/info/RouterForInfoPage';

import { FOOTER_TYPE_DEFAULT } from './routeConstant';

export const requestRoute = {
    path: ['/:requestKey'],
    component: RouterForInfoPage,
    view: NO_AUTH_VIEW,
    isAuthZone: false,
    doNotGetDataFromTomcat: true,
    stateOptions: {
        entryPoint: PROMO,
        strapiApi: '/api/v1/request-page/{:requestKey}',
        strapiApiUseCache: true,
        noIndex: true,
    },
    useSingleRoute: true,
};
export const newRequestRoute = {
    path: ['/new/:requestKey'],
    component: RouterForInfoPage,
    view: NO_AUTH_VIEW,
    isAuthZone: false,
    doNotGetDataFromTomcat: true,
    stateOptions: {
        entryPoint: PROMO,
        strapiApi: '/api/v1/not-registered-request-page/{:requestKey}',
        strapiApiUseCache: true,
        noIndex: true,
    },
    useSingleRoute: true,
};
export const libreRequestRoute = {
    path: ['/:requestKey'],
    component: LibreNoAuthChequePage,
    view: NO_AUTH_VIEW,
    isAuthZone: false,
    doNotGetDataFromTomcat: true,
    stateOptions: {
        entryPoint: PROMO,
        strapiApi: '/api/v2/libre-page/{:requestKey}',
        footerType: FOOTER_TYPE_DEFAULT,
        strapiApiUseCache: true,
        noIndex: true,
    },
    renderOptions: {
        isLibre: true,
    },
    useSingleRoute: true,
};
